import React from 'react';

// styles
import qmStyles from '../../../../../theme/qmStyles';
import containerStyles from '../Instructions.scss';

// images
import artHousehold from '../../../assets/art-household.png';

const JoinProperty = () => (
  <>
    <h3 className={containerStyles.titleText}>Join Property</h3>
    <img
      src={artHousehold}
      style={{ marginTop: qmStyles.gutter }}
      alt="household"
    />
    <p className={containerStyles.descriptionText}>
      Join a property that has been set up by someone in your household.
    </p>
  </>
);

export default JoinProperty;
